define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getTextHeight(_a) {
        var ctx = _a.ctx, text = _a.text, style = _a.style;
        var previousTextBaseline = ctx.textBaseline;
        var previousFont = ctx.font;
        ctx.textBaseline = 'bottom';
        ctx.font = style;
        var height = ctx.measureText(text).actualBoundingBoxAscent;
        ctx.textBaseline = previousTextBaseline;
        ctx.font = previousFont;
        return height;
    }
    exports.default = getTextHeight;
});
//# sourceMappingURL=DirectiveTextHeight.js.map